"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CachedClientBase = void 0;
const clientBase_1 = require("./clientBase");
class CachedClientBase extends clientBase_1.ClientBase {
    constructor(baseUrl, env, redisClient, logger) {
        super(baseUrl, env, logger);
        this._redisClient = redisClient;
    }
    getRedisClient() {
        if (this._redisClient && this._redisClient.isReady) {
            return this._redisClient;
        }
        return undefined;
    }
}
exports.CachedClientBase = CachedClientBase;
